export const isPropOrElse = (propName) => (thenValue, elseValue) => (props) =>
	props[propName] ? thenValue : elseValue;

export const selected = isPropOrElse("selected");
